export function sanitizeAcornFilename(name) {
    return (
        String(name || "quotation")
            .trim()
            .replace(/[^\w\u4e00-\u9fff\- ]+/g, "")
            .replace(/\s+/g, "-")
            .slice(0, 60) || "quotation"
    );
}

export function makeAcornFilename(projectName, quoteDateLabel) {
    const datePart = String(quoteDateLabel || "").replace(/\./g, "-") || "date";
    return `${sanitizeAcornFilename(projectName)}-quotation-${datePart}.png`;
}

export function canvasToAcornBlob(canvas) {
    return new Promise((resolve, reject) => {
        canvas.toBlob(
            (blob) => {
                if (blob) {
                    resolve(blob);
                } else {
                    reject(new Error("Canvas blob conversion failed"));
                }
            },
            "image/png"
        );
    });
}

export async function createAcornPosterAsset(canvas, filename) {
    const blob = await canvasToAcornBlob(canvas);
    return {
        blob,
        filename,
        url: URL.createObjectURL(blob),
    };
}

export function downloadAcornPoster(canvas, filename) {
    const link = document.createElement("a");
    link.download = filename;
    link.href = canvas.toDataURL("image/png");
    link.click();
}

function canShareAcornFiles() {
    if (typeof navigator === "undefined") {
        return false;
    }

    return Boolean(navigator.share);
}

export function canUseAcornShareSheet() {
    if (typeof navigator === "undefined") {
        return false;
    }

    return Boolean(navigator.canShare && navigator.share);
}

export async function shareAcornPoster(asset, title) {
    if (!canShareAcornFiles()) {
        return "unsupported";
    }

    const file = new File([asset.blob], asset.filename, { type: "image/png" });
    const payload = { files: [file], title };

    try {
        if (navigator.canShare) {
            if (!navigator.canShare(payload)) {
                return "unsupported";
            }
        }
        await navigator.share(payload);
        return "shared";
    } catch (error) {
        if (error && error.name === "AbortError") {
            return "cancelled";
        }
        throw error;
    }
}

export function openAcornPoster(asset) {
    const opened = window.open(asset.url, "_blank", "noopener");
    if (!opened) {
        window.location.href = asset.url;
    }
}
